import { Box, Typography, styled } from '@material-ui/core'
import { Link as RouterLink } from 'react-router-dom'

const LinkWrapper = styled(RouterLink)(({ selected }) => ({
    textDecoration: 'none',
    minHeight: '40px',
    padding: '0px 30px',
    backgroundColor: selected && 'rgba(48, 127, 193, 0.07)',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    transition: 'padding 0.5s ease',
    '&:hover': {
        backgroundColor: 'rgba(48, 127, 193, 0.07)',
    },
}))

const Tab = (props) => {
    const { to, icon, label, count, selected } = props
    return (
        <LinkWrapper to={to} selected={selected}>
            <Box display="flex" alignItems="center" minWidth="17px">
                {icon}
            </Box>
            <Box color="#000000" marginLeft="25px">
                <Typography variant="body1">{label}</Typography>
            </Box>

            <Box color="#919193" position="absolute" top="25%" right="30px">
                <Typography variant="body2">{count}</Typography>
            </Box>
        </LinkWrapper>
    )
}

export default Tab
